import { getQs, getUrl } from "src/utils";

// Decorates a HTTP client definition (body parsing, error handling etc.)
const method = definition => (url, params = {}, opts = {}) =>
  url
    ? definition(getUrl(url, params || {}), params || {}, opts || {})
        .catch(console.warn)
        .then(res => res.json())
        .catch(() => undefined)
        .then(json => json)
    : Promise.reject(`Provided url: ${url} is not valid`);

// The HTTP client
export const base = {
  get: method((url, params, opts = {}) => fetch(url + getQs(params), { ...opts, method: "GET" })),
  post: method((url, params, opts = {}) =>
    fetch(url, { ...opts, method: "POST", headers: { "Content-Type": "application/json", ...(opts.headers || {}) }, body: JSON.stringify(params) })
  ),
  put: method((url, params, opts = {}) =>
    fetch(url, { ...opts, method: "PUT", headers: { "Content-Type": "application/json", ...(opts.headers || {}) }, body: JSON.stringify(params) })
  ),
  delete: method((url, params, opts = {}) => fetch(url, { ...opts, method: "DELETE", body: JSON.stringify(params) }))
};
